import { render, staticRenderFns } from "./TopIPTableCard.vue?vue&type=template&id=14bec10c&scoped=true&"
import script from "./TopIPTableCard.vue?vue&type=script&lang=ts&"
export * from "./TopIPTableCard.vue?vue&type=script&lang=ts&"
import style0 from "./TopIPTableCard.vue?vue&type=style&index=0&id=14bec10c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14bec10c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VDataTable,VIcon,VRow})
